import { useForm } from "react-hook-form";
import { ajvResolver } from "@hookform/resolvers/ajv";
import { formSchema } from "../units/formSchema";

export const useInvoicesForm = (api) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: ajvResolver(formSchema),
    defaultValues: api,
  });

  return {
    form: api,
    errors,
    register,
    handleSubmit,
  };
};
